import { Action } from '@ngrx/store';
import {
  Address,
  Associate,
  ServiceAppointment as Appointment,
  AppointmentCase,
  QuoteDetail,
  Vehicle,
  WorkOrder,
  Note,
  QuoteSalesDetail,
  PartsRequestDetail,
  PartsRequest,
  AlternateTransportation,
} from '@quorum/models/xs-resource';
import {
  AssociateQueryParameters,
  QuoteHeaderQueryParameters,
  ServiceAppointmentDeclinedMpviCodeQueryParameters,
  ServiceAppointmentQueryParameters as AppointmentQueryParameters,
  VehicleQueryParameters,
  WorkOrderQueryParameters,
  AlternateTransportationQueryParameters,
} from '@quorum/models/xs-query';

export enum ServiceLaneActionTypes {
  ClearCustomerAndVehicleState = '[ServiceLane] Clear Customer And Vehicle From State',
  ClearAppointmentState = '[ServiceLane] Clear Appointment From State',
  GetCustomerAssociateFromServer = '[ServiceLane] Get Customer Associate From Server',
  GetCustomerAssociateFromServerError = '[ServiceLane] Get Customer Associate From Server Error',
  GetCustomerAssociateFromServerSuccess = '[ServiceLane] Get Customer Associate From Server Success',
  UpdateCustomerAssociateOnServerSuccess = '[ServiceLane] Update Customer Associate On Server Success',
  UpdateCustomerAddressOnServerSuccess = '[ServiceLane] Update Customer Address On Server Success',
  GetAllNotesFromServer = '[ServiceLane] Get All Notes From Server',
  GetAllNotesFromServerSuccess = '[ServiceLane] Get All Notes From Server Success',
  GetAllNotesFromServerError = '[ServiceLane] Get All Notes From Server Error',
  CreateNotesOnServer = '[ServiceLane] Create  Notes On Server',
  CreateNotesOnServerError = '[ServiceLane] Create Notes On Server Error',
  CreateNotesOnServerSuccess = '[ServiceLane] Create Notes On Server Success',
  CreateCustomerNotesOnServerSuccess = '[ServiceLane] Create Customer Notes On Server Success',
  CreateAppointmentNotesOnServerSuccess = '[ServiceLane] Create Appointment Notes On Server Success',
  CreateVehicleNotesOnServerSuccess = '[ServiceLane] Create Vehicle Notes On Server Success',
  UpdateNotesOnServer = '[ServiceLane] Update Notes On Server',
  UpdateNotesOnServerError = '[ServiceLane] Update Notes On Server Error',
  UpdateNotesOnServerSuccess = '[ServiceLane] Update Notes On Server Success',
  UpdateCustomerNotesOnServerSuccess = '[ServiceLane] Update Customer Notes On Server Success',
  UpdateAppointmentNotesOnServerSuccess = '[ServiceLane] Update Appointment Notes On Server Success',
  UpdateVehicleNotesOnServerSuccess = '[ServiceLane] Update Vehicle Notes On Server Success',
  CreateAppointmentCaseFromQuoteLine = '[ServiceLane] Create Appointment Case From a QuoteLine Workflow',
  CreateAppointmentCaseFromQuoteLineSuccess = '[ServiceLane] Create Appointment Case From a QuoteLine Workflow Success',
  CreateAppointmentCasesFromQuoteLines = '[ServiceLane] Create Appointment Cases From a QuoteLine Workflow',
  CreateAppointmentCasesFromQuoteLinesSuccess = '[ServiceLane] Create Appointment Cases From a QuoteLine Workflow Success',
  CreateAppointmentOnServerSuccess = '[ServiceLane] Create Appointment On Server Success',
  DeleteAppointmentFromServerSuccess = '[ServiceLane] Delete Appointment From Server Success',
  GetOpenAppointmentsFromServer = '[ServiceLane] Get Open Appointments From Server',
  GetOpenAppointmentsFromServerError = '[ServiceLane] Get Open Appointments From Server Error',
  GetOpenAppointmentsFromServerSuccess = '[ServiceLane] Get Open Appointmnets From Server Success',
  GetUnacknowledgedAppointmentsFromServer = '[ServiceLane] Get Unacknowledged Appointments From Server',
  GetUnacknowledgedAppointmentsFromServerError = '[ServiceLane] Get Unacknowledged Appointments From Server Error',
  GetUnacknowledgedAppointmentsFromServerSuccess = '[ServiceLane] Get Unacknowledged Appointments From Server Success',
  UpdateUnacknowledgedAppointmentsInState = '[ServiceLane] Update Unacknowledged Appointments In State',
  GetSelectedAppointmentFromServer = '[ServiceLane] Get Selected Appointment From Server',
  GetSelectedAppointmentFromServerError = '[ServiceLane] Get Selected Appointment From Server Error',
  GetSelectedAppointmentFromServerSuccess = '[ServiceLane] Get Selected Appointment From Server Success',
  UpdateSelectedAppointmentOnServer = '[ServiceLane] Update Selected Appointment From Server',
  UpdateSelectedAppointmentOnServerError = '[ServiceLane] Update Selected Appointment From Server Error',
  UpdateSelectedAppointmentOnServerSuccess = '[ServiceLane] Update Selected Appointment From Server Success',
  GetSelectedAppointmentCasesFromServerSuccess = '[ServiceLane] Get Selected Appointment Cases From Server Success',
  UpdateSelectedAppointmentCaseOnServerSuccess = '[ServiceLane] Update Selected Appointment Case On Server Success',
  DeleteSelectedAppointmentCaseOnServerSuccess = '[ServiceLane] Delete Selected Appointment Case On Server Success',
  CreateAppointmentCaseOnServerSuccess = '[ServiceLane] Create Appointment Case On Server Success',
  GetServiceHistoryFromServer = '[ServiceLane] Get Service History From Server',
  GetServiceHistoryFromServerError = '[ServiceLane] Get Service History From Server Error',
  GetServiceHistoryFromServerSuccess = '[ServiceLane] Get Service History From Server Success',
  GetTodaysAppointmentsFromServer = '[ServiceLane] Get Todays Appointments From Server',
  GetTodaysAppointmentsFromServerError = '[ServiceLane] Get Todays Appointments From Server Error',
  GetTodaysAppointmentsFromServerSuccess = '[ServiceLane] Get Todays Appointments From Server Success',
  DeleteTodaysAppointmentFromServerSuccess = '[ServiceLane] Delete Todays Appointments From Server Success',
  UpdateTodaysAppointmentsInState = '[ServiceLane] Update Todays Appointments In State',
  // eslint-disable-next-line max-len
  CreateVehicleWithAssociateAndAddressFromServer = '[ServiceLane] Create Vehicle With Associate And Address From Server',
  // eslint-disable-next-line max-len
  CreateVehicleWithAssociateAndAddressFromServerSuccess = '[ServiceLane] Create Vehicle With Associate And Address From Server Success',
  // eslint-disable-next-line max-len
  CreateVehicleWithAssociateAndAddressFromServerError = '[ServiceLane] Create Vehicle With Associate And Address From Server Error',
  CreateVehicleFromServerSuccess = '[ServiceLane] Create Vehicle From Server Success',
  GetQuoteFromServer = '[ServiceLane] Get Quote From Server',
  RemoveQuoteFromState = '[ServiceLane] Remove Quote From State',
  UpdateQuoteLineOnServerSuccess = '[ServiceLane] Update Quote Line On Server Success',
  UpdateQuoteLineInState = '[ServiceLane] Update Quote Line In State',
  GetVehicleFromServer = '[ServiceLane] Get Vehicle From Server',
  GetVehicleFromServerSuccess = '[ServiceLane] Get Vehicle From Server Success',
  GetVehicleFromServerError = '[ServiceLane] Get Vehicle From Server Error',
  SetVehicle = '[ServiceLane] Set Vehicle',
  // eslint-disable-next-line max-len
  GetServiceAppointmentDeclinedOperationsFromServer = '[ServiceLane] Get Service Appointment Declined Operations From Server',
  SetVerifyCustomerCreateWOButtonEnabledInState = '[ServiceLane] Set Verify Customer Button Enabled In State',
  SetWorkOrderRequiredFieldsPresentInState = '[ServiceLane] Set Work Order Required Fields Present In State',
  SetUnsavedLineItemInState = '[ServiceLane] Set Unsaved Line Item In State',
  SetMediaUploadingInState = '[ServiceLane] Set Media Uploading In State',
  UpdateAppointmentFiltersInState = '[ServiceLane] Update Appointment Filters In State',
  AddApprovedQuoteLineInState = '[ServiceLane] Add Approved Quote Line In State',
  UpdateApprovedQuoteLineInState = '[ServiceLane] Update Approved Quote Line In State',
  AddDeclinedQuoteLineInState = '[ServiceLane] Add Declined Quote Line In State',
  UpdateDeclinedQuoteLineInState = '[ServiceLane] Update Declined Quote Line In State',
  RemoveApprovedQuoteLineInState = '[ServiceLane] Remove Approved Quote Line In State',
  RemoveDeclinedQuoteLineInState = '[ServiceLane] Remove Declined Quote Line In State',
  AddQuoteLineInState = '[ServiceLane] Add Quote Line In State',
  TriggerCreateWorkOrderProcess = '[ServiceLane] Trigger Create Work Order Process',
  UpdateDeclinedReasonForQuoteLineInState = '[ServiceLane] Update Declined Reason For Quote Line In State',
  CreatePartDetailForQuoteLine = '[ServiceLane] Create Part Details for Quote Line',
  CreatePartDetailForQuoteLineSuccess = '[ServiceLane] Create Part Details for Quote Line Success',
  CreatePartsRequestDetailForQuoteLine = '[ServiceLane] Create Parts Request Detail for Quote Line',
  CreatePartsRequestDetailForQuoteLineSuccess = '[ServiceLane] Create Parts Request Detail for Quote Line Success',
  GetSelectedAppointmentCasesFromServerError = '[ServiceLane] Get Selected Appointment Cases From Server Error',
  GetAlternateTransportationsFromServer = '[ServiceLane] Get Alternate Transportations From Server',
  GetAlternateTransportationsFromServerSuccess = '[ServiceLane] Get Alternate Transportations From Server Success',
  GetAlternateTransportationsFromServerError = '[ServiceLane] Get Alternate Transportations From Server Error',
  CreateAlternateTransportationOnServer = '[ServiceLane] Create Alternate Transportation On Server',
  CreateAlternateTransportationOnServerSuccess = '[ServiceLane] Create Alternate Transportation On Server Success',
  CreateAlternateTransportationOnServerError = '[ServiceLane] Create Alternate Transportation On Server Error',
  UpdateAlternateTransportationOnServer = '[ServiceLane] Update Alternate Transportation On Server',
  UpdateAlternateTransportationOnServerSuccess = '[ServiceLane] Update Alternate Transportation On Server Success',
  UpdateAlternateTransportationOnServerError = '[ServiceLane] Update Alternate Transportation On Server Error',
  DeleteAlternateTransportationOnServer = '[ServiceLane] Delete Alternate Transportation On Server',
  DeleteAlternateTransportationOnServerSuccess = '[ServiceLane] Delete Alternate Transportation On Server Success',
  DeleteAlternateTransportationOnServerError = '[ServiceLane] Delete Alternate Transportation On Server Error',
}

export class TriggerCreateWorkOrderProcess implements Action {
  readonly type = ServiceLaneActionTypes.TriggerCreateWorkOrderProcess;
  constructor(public payload: {}) {}
}

export class ClearCustomerAndVehicleState implements Action {
  readonly type = ServiceLaneActionTypes.ClearCustomerAndVehicleState;
  constructor(public payload: {}) {}
}

export class ClearAppointmentState implements Action {
  readonly type = ServiceLaneActionTypes.ClearAppointmentState;
  constructor(public payload: {}) {}
}

//#region customer
export class GetCustomerAssociateFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetCustomerAssociateFromServer;
  constructor(public payload: AssociateQueryParameters) {}
}
export class GetCustomerAssociateFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetCustomerAssociateFromServerError;
  constructor(public payload: any) {}
}
export class GetCustomerAssociateFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetCustomerAssociateFromServerSuccess;
  constructor(public payload: { associate: Associate; address: Address }) {}
}
export class UpdateCustomerAssociateOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateCustomerAssociateOnServerSuccess;
  constructor(public payload: Associate) {}
}
export class UpdateCustomerAddressOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateCustomerAddressOnServerSuccess;
  constructor(public payload: Address) {}
}
export class GetAllNotesFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetAllNotesFromServer;
  constructor(public payload: { associateId: string; appointmentId: string; vehicleId: string }) {}
}
export class GetAllNotesFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetAllNotesFromServerError;
  constructor(public payload: any) {}
}
export class GetAllNotesFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetAllNotesFromServerSuccess;
  constructor(public payload: { customerNotes: Note; appointmentNotes: Note; vehicleNotes: Note }) {}
}
export class CreateNotesOnServer implements Action {
  readonly type = ServiceLaneActionTypes.CreateNotesOnServer;
  constructor(public payload: { newNote: Note; noteType: string }) {}
}
export class CreateNotesOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.CreateNotesOnServerError;
  constructor(public payload: any) {}
}
export class CreateNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class CreateCustomerNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateCustomerNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class CreateAppointmentNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class CreateVehicleNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateVehicleNotesOnServerSuccess;
  constructor(public payload: Note) {}
}
export class UpdateNotesOnServer implements Action {
  readonly type = ServiceLaneActionTypes.UpdateNotesOnServer;
  constructor(public payload: { newNote: Note; noteType: string }) {}
}
export class UpdateNotesOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.UpdateNotesOnServerError;
  constructor(public payload: any) {}
}
export class UpdateNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class UpdateCustomerNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateCustomerNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class UpdateAppointmentNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateAppointmentNotesOnServerSuccess;
  constructor(public payload: Note) {}
}

export class UpdateVehicleNotesOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateVehicleNotesOnServerSuccess;
  constructor(public payload: Note) {}
}
//#endregion

//#region open appointments
export class GetOpenAppointmentsFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetOpenAppointmentsFromServer;
  constructor(public payload: AppointmentQueryParameters) {}
}
export class GetOpenAppointmentsFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetOpenAppointmentsFromServerError;
  constructor(public payload: any) {}
}
export class GetOpenAppointmentsFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetOpenAppointmentsFromServerSuccess;
  constructor(public payload: Appointment[]) {}
}

export class CreateAppointmentOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentOnServerSuccess;
  constructor(public payload: Appointment) {}
}

export class DeleteAppointmentFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.DeleteAppointmentFromServerSuccess;
  constructor(public payload: { appointment: Appointment }) {}
}

//#endregion

//#region selected appointment
export class GetSelectedAppointmentFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetSelectedAppointmentFromServer;
  constructor(public payload: AppointmentQueryParameters) {}
}
export class GetSelectedAppointmentFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetSelectedAppointmentFromServerError;
  constructor(public payload: any) {}
}
export class GetSelectedAppointmentFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetSelectedAppointmentFromServerSuccess;
  constructor(public payload: Appointment) {}
}

export class UpdateSelectedAppointmentOnServer implements Action {
  readonly type = ServiceLaneActionTypes.UpdateSelectedAppointmentOnServer;
  constructor(public payload: Appointment) {}
}
export class UpdateSelectedAppointmentOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.UpdateSelectedAppointmentOnServerError;
  constructor(public payload: any) {}
}
export class UpdateSelectedAppointmentOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateSelectedAppointmentOnServerSuccess;
  constructor(public payload: Appointment) {}
}

export class GetSelectedAppointmentCasesFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetSelectedAppointmentCasesFromServerSuccess;
  constructor(public payload: { appointmentCases: AppointmentCase[] }) {}
}

export class UpdateSelectedAppointmentCaseOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateSelectedAppointmentCaseOnServerSuccess;
  constructor(public payload: { appointmentCase: AppointmentCase }) {}
}

export class DeleteSelectedAppointmentCaseOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.DeleteSelectedAppointmentCaseOnServerSuccess;
  constructor(public payload: { appointmentCase: AppointmentCase }) {}
}

export class CreateAppointmentCaseOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentCaseOnServerSuccess;
  constructor(public payload: { appointmentCase: AppointmentCase; quoteLine: QuoteDetail }) {}
}
//#endregion

//#region service-history
export class GetServiceHistoryFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetServiceHistoryFromServer;
  constructor(public payload: WorkOrderQueryParameters) {}
}
export class GetServiceHistoryFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetServiceHistoryFromServerError;
  constructor(public payload: any) {}
}
export class GetServiceHistoryFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetServiceHistoryFromServerSuccess;
  constructor(public payload: WorkOrder[]) {}
}
//#endregion

//#region todays appointments
export class GetTodaysAppointmentsFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetTodaysAppointmentsFromServer;
  constructor(public payload: AppointmentQueryParameters) {}
}
export class GetTodaysAppointmentsFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetTodaysAppointmentsFromServerError;
  constructor(public payload: any) {}
}
export class GetTodaysAppointmentsFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetTodaysAppointmentsFromServerSuccess;
  constructor(
    public payload: { appointments: Appointment[]; workOrderAppointments: WorkOrder[]; myAppointmentsToggle: boolean }
  ) {}
}

export class DeleteTodaysAppointmentFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.DeleteTodaysAppointmentFromServerSuccess;
  constructor(public payload: { appointment: Appointment }) {}
}

export class UpdateTodaysAppointmentInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateTodaysAppointmentsInState;
  constructor(public payload: { appointment: Appointment }) {}
}

//#endregion

//#region unacknowledged appointments
export class GetUnacknowledgedAppointmentsFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetUnacknowledgedAppointmentsFromServer;
  constructor(public payload: AppointmentQueryParameters) {}
}
export class GetUnacknowledgedAppointmentsFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetUnacknowledgedAppointmentsFromServerError;
  constructor(public payload: any) {}
}
export class GetUnacknowledgedAppointmentsFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetUnacknowledgedAppointmentsFromServerSuccess;
  constructor(public payload: Appointment[]) {}
}
export class UpdateUnacknowledgedAppointmentInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateUnacknowledgedAppointmentsInState;
  constructor(public payload: { appointment: Appointment }) {}
}

//#region vehicle

export class CreateVehicleFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateVehicleFromServerSuccess;
  constructor(public payload: Vehicle) {}
}

export class CreateVehicleWithAssociateAndAddressFromServer implements Action {
  readonly type = ServiceLaneActionTypes.CreateVehicleWithAssociateAndAddressFromServer;
  constructor(public payload: { vehicle: Vehicle; associate: Associate; address: Address; vehicleQueryParams?: any }) {}
}
export class CreateVehicleWithAssociateAndAddressFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateVehicleWithAssociateAndAddressFromServerSuccess;
  constructor(public payload: { vehicle: Vehicle; associate: Associate; address: Address }) {}
}
export class CreateVehicleWithAssociateAndAddressFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.CreateVehicleWithAssociateAndAddressFromServerSuccess;
  constructor(public payload: any) {}
}

export class GetQuoteFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetQuoteFromServer;
  constructor(public payload: QuoteHeaderQueryParameters) {}
}

export class RemoveQuoteFromState implements Action {
  readonly type = ServiceLaneActionTypes.RemoveQuoteFromState;
  constructor(public payload: QuoteDetail) {}
}

export class GetServiceAppointmentDeclinedOperationsFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetServiceAppointmentDeclinedOperationsFromServer;
  constructor(public payload: ServiceAppointmentDeclinedMpviCodeQueryParameters) {}
}

export class UpdateQuoteLineOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateQuoteLineOnServerSuccess;
  constructor(public payload: QuoteDetail) {}
}

export class UpdateQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateQuoteLineInState;
  constructor(public payload: QuoteDetail) {}
}

export class GetVehicleFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetVehicleFromServer;
  constructor(public payload: VehicleQueryParameters) {}
}
export class GetVehicleFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetVehicleFromServerError;
  constructor(public payload: any) {}
}
export class GetVehicleFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetVehicleFromServerSuccess;
  constructor(public payload: Vehicle) {}
}

export class SetVehicle implements Action {
  readonly type = ServiceLaneActionTypes.SetVehicle;
  constructor(public payload: Vehicle) {}
}
//#endregion
export class CreateAppointmentCaseFromQuoteLine implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentCaseFromQuoteLine;
  constructor(
    public payload: {
      quoteLine: QuoteDetail;
      appointmentId: number;
    }
  ) {}
}

export class CreateAppointmentCaseFromQuoteLineSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentCaseFromQuoteLineSuccess;
  constructor(
    public payload: {
      quoteLine: QuoteDetail;
      appointmentCase: AppointmentCase;
    }
  ) {}
}

export class CreateAppointmentCasesFromQuoteLines implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentCasesFromQuoteLines;
  constructor(
    public payload: {
      quoteHeaderId: number;
      quoteLineSequences: string;
      appointmentId: number;
    }
  ) {}
}

export class CreateAppointmentCasesFromQuoteLinesSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAppointmentCasesFromQuoteLinesSuccess;
  constructor(
    public payload: {
      quoteLineSequences: string;
      appointmentCases: AppointmentCase[];
    }
  ) {}
}

export class CreatePartDetailForQuoteLine implements Action {
  readonly type = ServiceLaneActionTypes.CreatePartDetailForQuoteLine;
  constructor(
    public payload: {
      partDetails: QuoteSalesDetail;
      quoteLine: QuoteDetail;
    }
  ) {}
}

export class CreatePartDetailForQuoteLineSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreatePartDetailForQuoteLineSuccess;
  constructor(
    public payload: {
      partDetails: QuoteSalesDetail;
      quoteLine: QuoteDetail;
    }
  ) {}
}

export class CreatePartsRequestDetailForQuoteLine implements Action {
  readonly type = ServiceLaneActionTypes.CreatePartsRequestDetailForQuoteLine;
  constructor(
    public payload: { partsRequest: PartsRequest; partsRequestDetail: PartsRequestDetail; quoteLine: QuoteDetail }
  ) {}
}

export class CreatePartsRequestDetailForQuoteLineSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreatePartsRequestDetailForQuoteLineSuccess;
  constructor(
    public payload: { partsRequest: PartsRequest; partsRequestDetail: PartsRequestDetail; quoteLine: QuoteDetail }
  ) {}
}

export class SetVerifyCustomerCreateWOButtonEnabledInState implements Action {
  readonly type = ServiceLaneActionTypes.SetVerifyCustomerCreateWOButtonEnabledInState;
  constructor(public payload: boolean) {}
}

export class SetWorkOrderRequiredFieldsPresentInState implements Action {
  readonly type = ServiceLaneActionTypes.SetWorkOrderRequiredFieldsPresentInState;
  constructor(public payload: { odometerIn: boolean; serviceAdvisorId: boolean; serviceCode: boolean }) {}
}

export class SetUnsavedLineItemInState implements Action {
  readonly type = ServiceLaneActionTypes.SetUnsavedLineItemInState;
  constructor(public payload: boolean) {}
}

export class SetMediaUploadingInState implements Action {
  readonly type = ServiceLaneActionTypes.SetMediaUploadingInState;
  constructor(public payload: boolean) {}
}

export class UpdateAppointmentFiltersInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateAppointmentFiltersInState;
  constructor(public payload: any) {}
}

export class AddApprovedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.AddApprovedQuoteLineInState;
  constructor(public payload: any) {}
}

export class UpdateApprovedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateApprovedQuoteLineInState;
  constructor(public payload: { quoteLine: QuoteDetail; previousId: number }) {}
}

export class AddDeclinedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.AddDeclinedQuoteLineInState;
  constructor(public payload: any) {}
}

export class UpdateDeclinedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateDeclinedQuoteLineInState;
  constructor(public payload: { quoteLine: QuoteDetail; previousId: number }) {}
}

export class UpdateDeclinedReasonForQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.UpdateDeclinedReasonForQuoteLineInState;
  constructor(public payload: { quoteLine: QuoteDetail }) {}
}

export class RemoveApprovedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.RemoveApprovedQuoteLineInState;
  constructor(public payload: any) {}
}

export class RemoveDeclinedQuoteLineInState implements Action {
  readonly type = ServiceLaneActionTypes.RemoveDeclinedQuoteLineInState;
  constructor(public payload: any) {}
}

export class GetAlternateTransportationsFromServer implements Action {
  readonly type = ServiceLaneActionTypes.GetAlternateTransportationsFromServer;
  constructor(public payload: AlternateTransportationQueryParameters) {}
}

export class GetAlternateTransportationsFromServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.GetAlternateTransportationsFromServerSuccess;
  constructor(public payload: AlternateTransportation[]) {}
}

export class GetAlternateTransportationsFromServerError implements Action {
  readonly type = ServiceLaneActionTypes.GetAlternateTransportationsFromServerError;
  constructor(public payload: any) {}
}

export class CreateAlternateTransportationOnServer implements Action {
  readonly type = ServiceLaneActionTypes.CreateAlternateTransportationOnServer;
  constructor(public payload: AlternateTransportation) {}
}

export class CreateAlternateTransportationOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.CreateAlternateTransportationOnServerSuccess;
  constructor(public payload: AlternateTransportation) {}
}

export class CreateAlternateTransportationOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.CreateAlternateTransportationOnServerError;
  constructor(public payload: any) {}
}

export class UpdateAlternateTransportationOnServer implements Action {
  readonly type = ServiceLaneActionTypes.UpdateAlternateTransportationOnServer;
  constructor(public payload: AlternateTransportation) {}
}

export class UpdateAlternateTransportationOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.UpdateAlternateTransportationOnServerSuccess;
  constructor(public payload: AlternateTransportation) {}
}

export class UpdateAlternateTransportationOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.UpdateAlternateTransportationOnServerError;
  constructor(public payload: any) {}
}

export class DeleteAlternateTransportationOnServer implements Action {
  readonly type = ServiceLaneActionTypes.DeleteAlternateTransportationOnServer;
  constructor(public payload: AlternateTransportation) {}
}

export class DeleteAlternateTransportationOnServerSuccess implements Action {
  readonly type = ServiceLaneActionTypes.DeleteAlternateTransportationOnServerSuccess;
  constructor(public payload: AlternateTransportation) {}
}

export class DeleteAlternateTransportationOnServerError implements Action {
  readonly type = ServiceLaneActionTypes.DeleteAlternateTransportationOnServerError;
  constructor(public payload: any) {}
}

export type ServiceLaneAction =
  | ClearCustomerAndVehicleState
  | ClearAppointmentState
  | GetCustomerAssociateFromServer
  | GetCustomerAssociateFromServerError
  | GetCustomerAssociateFromServerSuccess
  | UpdateCustomerAssociateOnServerSuccess
  | UpdateCustomerAddressOnServerSuccess
  | GetAllNotesFromServer
  | GetAllNotesFromServerError
  | GetAllNotesFromServerSuccess
  | CreateNotesOnServer
  | CreateNotesOnServerError
  | CreateNotesOnServerSuccess
  | CreateCustomerNotesOnServerSuccess
  | CreateAppointmentNotesOnServerSuccess
  | CreateVehicleNotesOnServerSuccess
  | UpdateNotesOnServer
  | UpdateNotesOnServerError
  | UpdateNotesOnServerSuccess
  | UpdateCustomerNotesOnServerSuccess
  | UpdateAppointmentNotesOnServerSuccess
  | UpdateVehicleNotesOnServerSuccess
  | GetOpenAppointmentsFromServer
  | GetOpenAppointmentsFromServerError
  | GetOpenAppointmentsFromServerSuccess
  | CreateAppointmentOnServerSuccess
  | CreateAppointmentCaseFromQuoteLine
  | CreateAppointmentCaseFromQuoteLineSuccess
  | CreateAppointmentCasesFromQuoteLines
  | CreateAppointmentCasesFromQuoteLinesSuccess
  | DeleteAppointmentFromServerSuccess
  | GetSelectedAppointmentFromServer
  | GetSelectedAppointmentFromServerError
  | GetSelectedAppointmentFromServerSuccess
  | UpdateSelectedAppointmentOnServer
  | UpdateSelectedAppointmentOnServerSuccess
  | UpdateSelectedAppointmentOnServerError
  | GetSelectedAppointmentCasesFromServerSuccess
  | UpdateSelectedAppointmentCaseOnServerSuccess
  | DeleteSelectedAppointmentCaseOnServerSuccess
  | CreateAppointmentCaseOnServerSuccess
  | GetServiceHistoryFromServer
  | GetServiceHistoryFromServerError
  | GetServiceHistoryFromServerSuccess
  | GetTodaysAppointmentsFromServer
  | GetTodaysAppointmentsFromServerError
  | GetTodaysAppointmentsFromServerSuccess
  | GetUnacknowledgedAppointmentsFromServer
  | GetUnacknowledgedAppointmentsFromServerError
  | GetUnacknowledgedAppointmentsFromServerSuccess
  | UpdateUnacknowledgedAppointmentInState
  | DeleteTodaysAppointmentFromServerSuccess
  | UpdateTodaysAppointmentInState
  | CreateVehicleWithAssociateAndAddressFromServer
  | CreateVehicleWithAssociateAndAddressFromServerError
  | CreateVehicleWithAssociateAndAddressFromServerSuccess
  | CreateVehicleFromServerSuccess
  | GetVehicleFromServer
  | GetVehicleFromServerError
  | GetVehicleFromServerSuccess
  | SetVehicle
  | UpdateQuoteLineOnServerSuccess
  | GetServiceAppointmentDeclinedOperationsFromServer
  | SetVerifyCustomerCreateWOButtonEnabledInState
  | SetWorkOrderRequiredFieldsPresentInState
  | SetUnsavedLineItemInState
  | SetMediaUploadingInState
  | RemoveQuoteFromState
  | UpdateAppointmentFiltersInState
  | AddApprovedQuoteLineInState
  | UpdateApprovedQuoteLineInState
  | AddDeclinedQuoteLineInState
  | UpdateDeclinedQuoteLineInState
  | UpdateDeclinedReasonForQuoteLineInState
  | RemoveApprovedQuoteLineInState
  | RemoveDeclinedQuoteLineInState
  | TriggerCreateWorkOrderProcess
  | CreatePartDetailForQuoteLine
  | CreatePartDetailForQuoteLineSuccess
  | CreatePartsRequestDetailForQuoteLine
  | GetAlternateTransportationsFromServer
  | GetAlternateTransportationsFromServerSuccess
  | GetAlternateTransportationsFromServerError
  | CreateAlternateTransportationOnServer
  | CreateAlternateTransportationOnServerSuccess
  | CreateAlternateTransportationOnServerError
  | UpdateAlternateTransportationOnServer
  | UpdateAlternateTransportationOnServerSuccess
  | UpdateAlternateTransportationOnServerError
  | DeleteAlternateTransportationOnServer
  | DeleteAlternateTransportationOnServerSuccess
  | DeleteAlternateTransportationOnServerError;

export const fromServiceLaneActions = {
  ClearCustomerAndVehicleState,
  ClearAppointmentState,
  GetCustomerAssociateFromServer,
  GetCustomerAssociateFromServerError,
  GetCustomerAssociateFromServerSuccess,
  GetAllNotesFromServer,
  GetAllNotesFromServerError,
  GetAllNotesFromServerSuccess,
  CreateNotesOnServer,
  CreateNotesOnServerError,
  CreateNotesOnServerSuccess,
  CreateCustomerNotesOnServerSuccess,
  CreateAppointmentNotesOnServerSuccess,
  CreateVehicleNotesOnServerSuccess,
  UpdateNotesOnServer,
  UpdateNotesOnServerError,
  UpdateNotesOnServerSuccess,
  UpdateCustomerNotesOnServerSuccess,
  UpdateAppointmentNotesOnServerSuccess,
  UpdateVehicleNotesOnServerSuccess,
  UpdateCustomerAssociateOnServerSuccess,
  UpdateCustomerAddressOnServerSuccess,
  GetOpenAppointmentsFromServer,
  GetOpenAppointmentsFromServerError,
  GetOpenAppointmentsFromServerSuccess,
  GetUnacknowledgedAppointmentsFromServer,
  GetUnacknowledgedAppointmentsFromServerError,
  GetUnacknowledgedAppointmentsFromServerSuccess,
  GetSelectedAppointmentFromServer,
  GetSelectedAppointmentFromServerError,
  GetSelectedAppointmentFromServerSuccess,
  UpdateSelectedAppointmentOnServer,
  UpdateSelectedAppointmentOnServerSuccess,
  UpdateSelectedAppointmentOnServerError,
  GetSelectedAppointmentCasesFromServerSuccess,
  UpdateSelectedAppointmentCaseOnServerSuccess,
  CreateAppointmentCaseOnServerSuccess,
  CreateAppointmentCaseFromQuoteLine,
  CreateAppointmentCaseFromQuoteLineSuccess,
  CreateAppointmentCasesFromQuoteLines,
  CreateAppointmentCasesFromQuoteLinesSuccess,
  GetServiceHistoryFromServer,
  GetServiceHistoryFromServerError,
  GetServiceHistoryFromServerSuccess,
  GetTodaysAppointmentsFromServer,
  GetTodaysAppointmentsFromServerError,
  GetTodaysAppointmentsFromServerSuccess,
  CreateVehicleWithAssociateAndAddressFromServer,
  CreateVehicleWithAssociateAndAddressFromServerError,
  CreateVehicleWithAssociateAndAddressFromServerSuccess,
  CreateVehicleFromServerSuccess,
  GetVehicleFromServer,
  GetVehicleFromServerSuccess,
  GetVehicleFromServerError,
  SetVehicle,
  UpdateQuoteLineOnServerSuccess,
  GetServiceAppointmentDeclinedOperationsFromServer,
  SetVerifyCustomerCreateWOButtonEnabledInState,
  SetUnsavedLineItemInState,
  SetMediaUploadingInState,
  SetWorkOrderRequiredFieldsPresentInState,
  RemoveQuoteFromState,
  UpdateAppointmentFiltersInState,
  AddApprovedQuoteLineInState,
  UpdateApprovedQuoteLineInState,
  AddDeclinedQuoteLineInState,
  UpdateDeclinedQuoteLineInState,
  UpdateDeclinedReasonForQuoteLineInState,
  RemoveApprovedQuoteLineInState,
  RemoveDeclinedQuoteLineInState,
  TriggerCreateWorkOrderProcess,
  CreatePartDetailForQuoteLine,
  CreatePartDetailForQuoteLineSuccess,
  CreatePartsRequestDetailForQuoteLine,
  CreatePartsRequestDetailForQuoteLineSuccess,
  GetAlternateTransportationsFromServer,
  GetAlternateTransportationsFromServerSuccess,
  GetAlternateTransportationsFromServerError,
  CreateAlternateTransportationOnServer,
  CreateAlternateTransportationOnServerSuccess,
  CreateAlternateTransportationOnServerError,
  UpdateAlternateTransportationOnServer,
  UpdateAlternateTransportationOnServerSuccess,
  UpdateAlternateTransportationOnServerError,
  DeleteAlternateTransportationOnServer,
  DeleteAlternateTransportationOnServerSuccess,
  DeleteAlternateTransportationOnServerError,
};
